import { UIHeading4, UIText2 } from '@cian/ui-kit';
import classNames from 'classnames';
import * as React from 'react';
import { useIsMobileDevice } from '../../../../hooks';
import { IRosreestrData } from '../../../../types/reducers/rosreestrData';
import * as styles from './ModalContent.css';

export const ModalContent: React.FC<IRosreestrData['cardView']> = ({ parts }) => {
  const isMobile = useIsMobileDevice();

  return (
    <div>
      {parts.map(({ header, elements }) => (
        <div className={styles['block']} key={header}>
          <div className={styles['header']}>
            <UIHeading4>{header}</UIHeading4>
          </div>

          {elements.map(({ title, value }) => (
            <div className={classNames(styles['row'], isMobile && styles['mobile'])} key={title}>
              <div className={styles['cell']}>
                <UIText2 color="gray60_100">{title}</UIText2>
              </div>
              <div className={styles['cell']}>
                <UIText2>{value}</UIText2>
              </div>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};
